import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { applyPolyfills, defineCustomElements } from 'digital-guidelines-core/loader';


// Bind the custom elements to the window object
applyPolyfills().then(() => {
    defineCustomElements();
  });

const app = createApp(App);
app.config.compilerOptions.isCustomElement = tag => tag.startsWith('som-');
app.use(store); 
app.use(router);
app.mount('#app')
